import { toast } from 'sonner';
import i18n from '@/i18n';
import { ApiError, NetworkError } from '@/api/client';
import { go } from '@/lib/navigation';

/** Human message for any thrown value, in the active language. */
export function errorMessage(error: unknown): string {
  if (error instanceof NetworkError) return i18n.t('errors.network');
  if (error instanceof ApiError) {
    if (error.status === 403) return error.detail ?? i18n.t('errors.forbidden');
    if (error.status === 404) return error.detail ?? i18n.t('errors.notFound');
    if (error.status === 409) return error.detail ?? i18n.t('errors.conflict');
    if (error.status >= 500) return i18n.t('errors.server');
    const fieldMessages = Object.values(error.fieldErrors).flat();
    if (error.detail) return error.detail;
    if (fieldMessages.length) return fieldMessages.join(' ');
    return error.title;
  }
  if (error instanceof Error && error.message) return error.message;
  return i18n.t('errors.unknown');
}

/** Where to get the membership a refused action needed (402 membership_required), or null for any other error. */
export function membershipLink(error: unknown): string | null {
  if (!(error instanceof ApiError) || error.status !== 402 || error.problem?.code !== 'membership_required') return null;
  return error.problem.audience === 'Tester' ? '/my/membership'
    : `/org/membership${error.problem.organizationId ? `?org=${error.problem.organizationId}` : ''}`;
}

export function toastError(error: unknown, title?: string) {
  const link = membershipLink(error);
  toast.error(title ?? errorMessage(error), {
    ...(title ? { description: errorMessage(error) } : {}),
    // A lapsed membership: one click to where it can be renewed.
    ...(link ? { id: 'membership-required', action: { label: i18n.t('membership.openPage'), onClick: () => go(link) } } : {}),
  });
}
